/**
 * this is empty file for unofficial workaround for legacy js polyfills
 * - https://github.com/vercel/next.js/discussions/64330#discussioncomment-16384266
 */
